import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Language {
  /**
   * @return function(Dispatch)->Country.list
   */
  public static async load() {
    useDispatch(Action.Location.Country.setStatus("loading"));
    try {
      const response = await new Model.Language().list();
      useDispatch(Action.Language.setList(response.data));
      useDispatch(Action.Language.setStatus("loaded"));
      return response.data;
    } catch (Exception) {}
  }
}
